<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL DEWORMING DETAIL
          </h2>
          <!--<p>Create animal deworming detail</p>-->
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <br>
      <form class="row" [formGroup]="deworming_detail">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Deworming Name<span
                style="color: rgb(243, 60, 60);padding-left: 5px;">*</span></label>
            <input type="text" name="dewormingname" id="dewormingname" value="" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="deworming_name">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Deworming Date<span
                style="color: rgb(243, 60, 60);padding-left: 5px;">*</span></label>
            <input type="date" name="DeworminDate" id="DewormingDate" value="" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="deworming_date">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Batch No<span style="color: rgb(243, 60, 60);padding-left: 5px;">*</span></label>
            <input type="text" name="batchNumber" id="batchNumber" value="" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="batch_number">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Expiry Date<span
                style="color: rgb(243, 60, 60);padding-left: 5px;">*</span></label>
            <input type="date" id="ExpiryDate" value="Cow" class="form-control" [ngModelOptions]="{standalone: true}"
              [(ngModel)]="expiry_date">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div> -->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Expiry Date<span style="color: rgb(243, 60, 60);padding-left: 5px;">*</span></label>
            <input type="date" id="ExpiryDate"  class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="expiry_date">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Description</label>
            <textarea id="Description" name="Description" class="form-control"></textarea>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button type="submit" class="btn btn-fill btn-primary mb-3" (click)="AnimalDeworming()">Submit<div
              class="ripple-container"></div></button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>